<template>
  <Wrapper
    v-show="
      component &&
      !preview && renderTools &&
      ![
        'reheight_widget',
        'remargin_widget',
        'crop_image',
        'sort_widget',
      ].includes(mode) &&
      widgetActive.id
    "
    id="widget-active-frame"
    :class="{'top': !isOverScroll && (!isFirstSection || !oversection), 'bottom': isOverScroll || (isFirstSection && oversection), [`widget-active-frame-${widgetActive.theme}`]: Boolean(widgetActive.theme) }"
    :position="elemWidgetActive.params.position"
    @click.stop.prevent
  >
    <!-- <WidgetHover class="active lbl-name p-0">
      <b-dropdown :dropup="!isOverScroll" :dropdown="isOverScroll" :class="{'top': !isOverScroll, 'bottom': isOverScroll}">
        <template #button-content>
          {{ widgetTypeShow }} <i class="fas" :class="{'fa-caret-up': !isOverScroll, 'fa-caret-down': isOverScroll}"></i>
        </template>
        <b-dropdown-item @click="goTo('section')">Section</b-dropdown-item>
        <b-dropdown-item @click="goTo('grid')">Grid</b-dropdown-item>
        <b-dropdown-item @click="goTo('cell')">Cell</b-dropdown-item>
      </b-dropdown>
    </WidgetHover> -->
    <WidgetHover 
      id="widget-active-label"
      class="active"
      :class="{'lbl-name' : isHeaderWidgetOnTopBar ,'label-name-frame' : !isHeaderWidgetOnTopBar, }"
      :style="{'left': isWidgetOverlap ? indexCell == 0 ? '106px' : isSlideContainerWidget ? '86px' : '54px' : '0px'}"
      >
      {{ widgetTypeShow }}
    </WidgetHover>

    <!-- Toolbar -->
    <WidgetTool id="widget-tool" v-if="component && widgetActive.toolbarEnable && mode != 'resizing' && !hideTool" class="d-flex align-items-center widget-tool" style="z-index: 5;"
      :marginHeight="component.style[attr] ? component.style[attr] : 0"
      :positionTool="positionTool"
    >
      <b-badge id="widget-tool-badge"
        v-if="!((getDynamicComponent == undefined) && isSystemWidget)"
        pill
        variant="light"
        class="d-flex align-items-center mb-10 my-2"
        :class="{'top': !isOverScroll && (!isFirstSection || !oversection), 'bottom': isOverScroll || (isFirstSection && oversection), 'header-widget': isHeaderWidget}"
      >
        <component
          :v-if="getDynamicComponent"
          :component="component"
          :is="getDynamicComponent"
          @callbackResize="callbackResize"
        />
        <!-- <div v-b-tooltip.hover title="link widget" class="ml-2 cursor-pointer">
          <i class="fas fa-link"></i>
        </div> -->
        <div class="cursor-pointer btn-tool"
          v-show="!isSystemWidget && !(detectDevice === 'mobile' && typeNotShowTrash.includes(widgetTypeShow)) && !isHeaderWidget && !isFooterWidget && !ignoreCentralDelete && detectDevice !== 'mobile'"
          @click="duplicateWidget()"
          :title="$t('engine.floatframeTool.btnHover.tooltip.lblDuplicate', languageEngine)"
          v-b-tooltip.hover 
        >
          <i class="far fa-clone" style="width: 15px; height: 15px"></i>
        </div>
        <div
          v-show="!isSystemWidget && !(detectDevice === 'mobile' && typeNotShowTrash.includes(widgetTypeShow)) && !isHeaderWidget && !isFooterWidget && !ignoreCentralDelete && detectDevice !== 'mobile'"
          @click="removeWidget"
          v-b-tooltip.hover
          :title="$t('engine.floatframeTool.btnHover.tooltip.lblRemove',languageEngine)"
          class="cursor-pointer btn-tool"
        >
          <i class="far fa-trash-alt" style="width: 15px; height: 15px"></i>
        </div>
      </b-badge>
    </WidgetTool>

    <WidgetHover 
      v-if="getDynamicComponentTool"
      id="widget-active-tool"
      class="active"
      :class="{'lbl-name' : isHeaderWidgetOnTopBar ,'label-name-frame' : !isHeaderWidgetOnTopBar, }"
      style="left: 100%; transform: translate(-100%); padding : 0; width:auto; height :auto;"
    >
      <component
        v-if="getDynamicComponentTool"
        :component="component"
        :is="getDynamicComponentTool"
        @callbackResize="callbackResize"
      />
    </WidgetHover>

    <!-- <ImageResize
      v-if="resizeable"
      @callbackResize="callbackResize"
      :component="component"
    /> -->

    <MapResize
      v-if="widgetTypeShow === 'Map'"
      @callbackResize="callbackResize"
      :component="component"
    />

    <LineSeparateResize
      v-if="widgetTypeShow === 'Line'"
      @callbackResize="callbackResize"
      :component="component"
    />

    <!-- Reheight -->
    <Reheight v-if="checkShowReHeight" :component_id="component.id" />
    <!-- ResizeDot -->
    <component
      v-if="widgetActive.resizeDotEnable"
      :is="getDynamicResizeDot"
      :component="component" 
    />

  </Wrapper>
</template>

<script>
import { WidgetHover } from "./WidgetHover.styled";
import { WidgetTool, Wrapper } from "./WidgetActive.styled";
// import ImageResize from "../Image/tool/ImageResize.vue";
import LineSeparateResize from "../LineSeparate/tool/LineSeparateResize";
import MapResize from "../Map/tool/MapResize";
import Reheight from "@components/dynamic/widget/Share/Reheight";
import { mapGetters } from "vuex";
import { WIDGET, SYSTEM_WIDGET, HEADER_WIDGET,FOOTER_WIDGET } from "@model/components/componentMeta.model";
import { SECTION_TYPE_NONE_SETTING } from "@model/components/componentMeta.model";

const components = {
  // unit widget
  [WIDGET.prefixType + "IMAGE_TOOL"]: () =>
    import("@components/dynamic/widget/Image/tool/ImageTool"),
  [WIDGET.prefixType + "FORM_TOOL"]: () =>
    import("@components/dynamic/widget/Form/tool/FormTool"),
  [WIDGET.prefixType + "ICON_TOOL"]: () =>
    import("@components/dynamic/widget/Icon/tool/IconTool"),
  [WIDGET.prefixType + "YOUTUBE_TOOL"]: () =>
    import("@components/dynamic/widget/Youtube/tool/ImageTool"),
  [WIDGET.prefixType + "LINE_SEPARATE_TOOL"]: () =>
    import("@components/dynamic/widget/LineSeparate/tool/LineSeparateTool"),
  [WIDGET.prefixType + "SOCIAL_TOOL"]: () =>
    import("@components/dynamic/widget/Social/tool/SocialTool"),
  [WIDGET.prefixType + "INTERACTIVE_TOOL"]: () =>
    import("@components/dynamic/widget/Interactive/tool/InteractiveTool.vue"),
  [WIDGET.prefixType + "TEXT_TOOL"]: () =>
    import("@components/dynamic/widget/Text/Tools/Tool"),
  [WIDGET.prefixType + "IMAGE_GALLERY_TOOL"]: () =>
    import("@components/dynamic/widget/ImageGallery/tool/AddImage"),
  [WIDGET.prefixType + "PRODUCT_BRAND_TOOL"]: () =>
    import("@components/dynamic/widget/ProductBrand/tool/addBrands"),
  [WIDGET.prefixType + "BUTTON_TOOL"]: () =>
    import("@components/dynamic/widget/Button/tool/ButtonTool"),
  [WIDGET.prefixType + "COUNTER_TOOL"]: () =>
    import("@components/dynamic/widget/Counter/tool/CounterTool"),
  [WIDGET.prefixType + "CONTACT_TOOL"]: () =>
    import("@components/dynamic/widget/Contact/tool/ContactTool"),
  [WIDGET.prefixType + "MAP_TOOL"]: () =>
    import("@components/dynamic/widget/Map/tool/MapTool"),
  [WIDGET.prefixType + "HTML_TOOL"]: () =>
    import("@components/dynamic/widget/Html/tool/HtmlTool"),
  [WIDGET.prefixType + "TABLE_TOOL"]: () =>
    import("@components/dynamic/widget/Table/tool/TableTool"),
  // [WIDGET.prefixType + "TIKTOK_TOOL"]: () =>
  //   import("@components/dynamic/widget/Tiktok/tool/TiktokTool"),
  // [WIDGET.prefixType + "MENU_PRODUCT_TOOL"]: () =>
  //   import("@components/dynamic/widget/MenuProduct/tool/MenuProductTool"),

  [SYSTEM_WIDGET.prefixType + "TEXT_TOOL"]: () =>
    import("@components/dynamic/widget/Text/Tools/Tool"),
  [SYSTEM_WIDGET.prefixType + "IMAGE_TOOL"]: () =>
    import("@components/dynamic/widget/SystemImage/tool/ImageTool"),
  [HEADER_WIDGET.prefixType + "MENU_TOOL"]: () =>
    import("@components/header/widget/header_widget_menu/tool/HeaderMenuTool"),
  [HEADER_WIDGET.prefixType + "LOGO_TOOL"]: () =>
    import("@components/header/widget/header_widget_logo/tool/HeaderLogoTool"),
  [HEADER_WIDGET.prefixType + "CART_TOOL"]: () =>
    import("@components/header/widget/header_widget_cart/tool/HeaderCartTool"),
  [HEADER_WIDGET.prefixType + "LANGUAGE_TOOL"]: () =>
    import("@components/header/widget/header_widget_language/tool/HeaderLanguageTool"),
  [HEADER_WIDGET.prefixType + "CURRENCY_TOOL"]: () =>
    import("@components/header/widget/header_widget_currency/tool/HeaderCurrencyTool"),
  [HEADER_WIDGET.prefixType + "SOCIAL_TOOL"]: () =>
    import("@components/header/widget/header_widget_social/tool/HeaderSocialTool"),
  [HEADER_WIDGET.prefixType + "SEARCH_TOOL"]: () =>
    import("@components/header/widget/header_widget_search/tool/HeaderSearchTool"),
  [HEADER_WIDGET.prefixType + "MEMBER_TOOL"]: () =>
    import("@components/header/widget/header_widget_member/tool/HeaderMemberTool"),
  [HEADER_WIDGET.prefixType + "TOPMENU_TOOL"]: () =>
    import("@components/header/widget/header_widget_topmenu/tool/HeaderTopMenuTool"),
  [HEADER_WIDGET.prefixType + "TEXT_TOOL"]: () =>
    import("@components/header/widget/header_widget_text/tool/HeaderTextTool"),
  [HEADER_WIDGET.prefixType + "QUOTATION_TOOL"]: () =>
    import("@components/header/widget/header_widget_quotation/tool/HeaderQuotationTool"),
  [FOOTER_WIDGET.prefixType + "SOCIAL_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_social/tool/FooterSocialTool"),
  [FOOTER_WIDGET.prefixType + "LOGO_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_logo/tool/FooterLogoTool"),
  [FOOTER_WIDGET.prefixType + "MENU_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_menu/tool/FooterMenuTool"),
  [FOOTER_WIDGET.prefixType + "PARTNER_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_partner/tool/FooterPartnerTool"),
  [FOOTER_WIDGET.prefixType + "SUBSCRIBE_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_subscribe/tool/FooterSubscribeTool"),
  [FOOTER_WIDGET.prefixType + "COPYRIGHT_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_copyrighttext/tool/FooterCopyrightTool"),
  [FOOTER_WIDGET.prefixType + "COPYRIGHT_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_copyrighttext/tool/FooterCopyrightTool"),
  [FOOTER_WIDGET.prefixType + "STATCOUNTER_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_stat/tool/FooterStatTool"),
  [FOOTER_WIDGET.prefixType + "TEXT1_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_text/tool/FooterText1Tool"),
  [FOOTER_WIDGET.prefixType + "TEXT2_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_text/tool/FooterText1Tool"),
  [FOOTER_WIDGET.prefixType + "TEXT3_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_text/tool/FooterText1Tool"),
  [FOOTER_WIDGET.prefixType + "TEXT4_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_text/tool/FooterText1Tool"),
  [FOOTER_WIDGET.prefixType + "FBLIKEBOX_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_facebooklikebox/tool/FooterLikeboxTool"),
  [FOOTER_WIDGET.prefixType + "PAYMENT_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_payment/tool/FooterPaymentTool"),
  [FOOTER_WIDGET.prefixType + "SHIPPING_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_shipping/tool/FooterShippingTool"),
  [FOOTER_WIDGET.prefixType + "TAGS_TOOL"]: () =>
    import("@components/footer/widget/footer_widget_tags/tool/FooterTagsTool"),
  [WIDGET.prefixType + "QUOTATION_FORM_TOOL"]: () =>
    import("@components/dynamic/widget/QuotationForm/tool/QuotationFormTool"),
};

const tools = {
  [WIDGET.prefixType + "IMAGE_GALLERY_TOOL_ACTIVE"]: () =>
    import("@components/dynamic/widget/ImageGallery/tool/ChangeSlide"),
}

const ResizeDots = {
  [WIDGET.prefixType + "TEXT__RESIZEDOT"]: () => import("@components/dynamic/widget/Text/Tools/ResizeDot"),
  [WIDGET.prefixType + "INTERACTIVE__RESIZEDOT"]: () => import("@components/dynamic/widget/Interactive/tool/ResizeDot"),
  [WIDGET.prefixType + "IMAGE__RESIZEDOT"]: () => import("@components/dynamic/widget/Image/tool/ResizeDot"),
  [WIDGET.prefixType + "YOUTUBE__RESIZEDOT"]: () => import("@components/dynamic/widget/Youtube/tool/ResizeDot"),
  [WIDGET.prefixType + "MENU_PRODUCT__RESIZEDOT"]: () => import("@components/dynamic/widget/MenuProduct/tool/MenuProductResize"),
  [WIDGET.prefixType + "BUTTON__RESIZEDOT"]: () => import("@components/dynamic/widget/Button/tool/ResizeDot"),
  [WIDGET.prefixType + "HTML__RESIZEDOT"]: () => import("@components/dynamic/widget/Html/tool/ResizeDot"),
  [WIDGET.prefixType + "PRODUCT_CATEGORY__RESIZEDOT"]: () => import("@components/dynamic/widget/ProductCategory/tool/ResizeDot"),
  [WIDGET.prefixType + "TABLE__RESIZEDOT"]: () => import("@components/dynamic/widget/Table/tool/ResizeDot"),
}

const componentsKey = Object.keys(components);
const toolsKey = Object.keys(tools);
const resizeDotKeys = Object.keys(ResizeDots);

export default {
  components: {
    WidgetHover,
    WidgetTool,
    Wrapper,
    // ImageResize,
    LineSeparateResize,
    MapResize,
    Reheight,
    ...components,
    ...tools,
    ...ResizeDots,
  },
  data() {
    return {
      positionTool: {},
      topElementPosition: 0,
      typeNotShowTrash : ['Image','Image Gallery','Form','Button','Contact','Line','Album','Youtube','Interactive', 'Social', 'Map'],
      refs: {
        widgetTool: undefined,
      },
    }
  },
  watch: {
    mode() {
      this.$nextTick(function () {
        this.$store.dispatch("designIframe/component/setComponentAction", {
          component_id: this.widgetActive.id,
          type: "WIDGET",
          action: "ACTIVE",
        });
      });
    },
    widgetActive: {
      deep: true,
      handler() {
        const element = document.getElementById("widget-active-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
          })
        }
      }
    },
    framePosition: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.calPositionTool()
        })
      }
    },
    compMargin:{
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.compMargin;
          
        })
      }
    },
    detectDevice() {
      this.$store.dispatch("designIframe/frame/resetFrame");
    }
  },
  computed: {
    ...mapGetters({
      scrollPosition: "scrollPosition",
      widgetActive: "designIframe/frame/widgetActive",
      parentWidgetActive: "designIframe/frame/parentWidgetActive",
      widgetHover: "designIframe/frame/widgetHover",
      cellHover: "designIframe/frame/cellHover",
      slideSectionActive: "designIframe/frame/slideSectionActive",
      preview: "designIframe/preview",
      components: "designIframe/metadata/components",
      siteComponents: "designIframe/metadata/siteComponents",
      mode: "designIframe/mode",
      detectDevice: "detectDevice",
      elActiveID: "designIframe/component/elActiveID",
      screenWidth: "screenWidth",
      renderTools: "designIframe/frame/renderTools",
      languageEngine: "designIframe/userPreference/languageEngine",
      CONTENT_CONTAINER: "designIframe/metadata/CONTENT_CONTAINER",
      sitePageID: "designIframe/metadata/sitePageID",

    }),
    isSystemWidget() {
      return this.component && this.component.type.includes("SYSTEM_WIDGET") ? true : false
    },
    isHeaderWidget() {
      return this.component && this.component.type.includes("HEADER_WIDGET") ? true : false
    },
    isFooterWidget() {
      return this.component && this.component.type.includes("FOOTER_WIDGET") ? true : false
    },
    isSlideContainerWidget() {
      return this.parent_id && this.parent_id.includes("slc") ? true : false
    },
    ignoreCentralDelete() {
      return Boolean(this.component && [
        'SECTION_WIDGET_TEXT',
        'SECTION_WIDGET_COUNTER',
      ].includes(this.component.type));
    },
    isHeaderWidgetOnTopBar() {
      if (this.isHeaderWidget) {
        let el = document.getElementById('comp-' + this.widgetActive.id)
        let elTop = document.getElementById('top-mb');
        if (el && el.classList.contains('on-topbar') || (!elTop && this.widgetActive.id.includes('HEADER'))) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    resizeable() {
      return ["image", "youtube", "icon"].includes(
        this.widgetTypeShow.toLowerCase()
      );
    },
    getDynamicComponent() {
      if (componentsKey.includes(this.widgetType + "_TOOL")) {
        return this.widgetType + "_TOOL";
      } else {
        return undefined;
      }
    },
    getDynamicComponentTool() {
      if (toolsKey.includes(this.widgetType + "_TOOL_ACTIVE")) {
        if(this.widgetType + "_TOOL_ACTIVE" == 'SECTION_WIDGET_IMAGE_GALLERY_TOOL_ACTIVE' && this.component.style.layout != 3 ) {
          return undefined;
        }
        return this.widgetType + "_TOOL_ACTIVE";
      } else {
        return undefined;
      }
    },
    getDynamicResizeDot() {
      if (resizeDotKeys.includes(`${this.widgetType}__RESIZEDOT`)) {
        return `${this.widgetType}__RESIZEDOT`;
      } else {
        return undefined;
      }
    },
    parent_id() {
      return this.widgetActive.id && !this.isHeaderWidget && !this.isFooterWidget &&  this.widgetActive.id && !this.isHeaderWidget 
      && Object.entries(this.components).filter(
        (item) =>
          item[1].componentsID &&
          item[1].componentsID.includes(this.widgetActive.id) ||
          item[1].componentsIDHover &&
          item[1].componentsIDHover.includes(this.widgetActive.id)
      )[0][0];
    },
    grid_id() {
      return this.parent_id && Object.entries(this.components).filter(
        (item) =>
          item[1].componentsID &&
          item[1].componentsID.includes(this.parent_id)
      )[0][0];
    },
    section_id() {
      return this.grid_id && Object.entries(this.components).filter(
        (item) =>
          item[1].componentsID &&
          item[1].componentsID.includes(this.grid_id)
      )[0][0];
    },
    component() {
      if (this.widgetActive.id && (this.widgetActive.id.includes('HEADER') || this.widgetActive.id && this.widgetActive.id.includes('FOOTER'))) {
        return this.siteComponents[this.widgetActive.id];
      } else {
        return this.components[this.widgetActive.id];
      }
    },
    componentStyle() {
      return this.component.style;
    },
    widgetType() {
      return this.component && this.component.type;
    },
    widgetTypeShow() {
      if(!this.widgetType) return "";
      let type = "";
      switch (this.widgetType) {
        case "SECTION_WIDGET_LINE_SEPARATE":
          type = "Line";
          break;
        case "SECTION_WIDGET_CONTENT":
          type = "Blog";
          break;
        case "HEADER_WIDGET_MENU":
          type = "Header Menu";
          break;
        case "HEADER_WIDGET_LOGO":
          type = "Logo";
          break;
        case "HEADER_WIDGET_MEMBER":
          type = "Member";
          break;
        case "HEADER_WIDGET_SOCIAL":
          type = "Social";
          break;
        case "HEADER_WIDGET_LANGUAGE":
          type = "Language";
          break;
        case "HEADER_WIDGET_CURRENCY":
          type = "Currency";
          break;
        case "HEADER_WIDGET_SEARCH":
          type = "Search";
          break;
        case "HEADER_WIDGET_TEXT":
          type = "Text";
          break;
        case "HEADER_WIDGET_TOPMENU":
          type = "Top Menu";
          break;
        case "HEADER_WIDGET_CART":
          type = "Cart";
          break;
        case "HEADER_WIDGET_QUOTATION":
          type = "Quote";
          break;
        case "FOOTER_WIDGET_MENU":
          type = "Footer Menu";
          break;
        case "FOOTER_WIDGET_LOGO":
          type = "Logo";
          break;
        case "FOOTER_WIDGET_SUBSCRIBE":
          type = "Subscribe";
          break;
        case "FOOTER_WIDGET_SOCIAL":
          type = "Social";
          break;
        case "FOOTER_WIDGET_PARTNER":
          type = "Logo Partner";
          break;
        case "FOOTER_WIDGET_COPYRIGHT":
          type = "Copyright";
          break;
        case "FOOTER_WIDGET_STATCOUNTER":
          type = "Stat Counter";
          break;
        case "FOOTER_WIDGET_TEXT1":
          type = "Text";
          break;
        case "FOOTER_WIDGET_TEXT2":
          type = "Text";
          break;
        case "FOOTER_WIDGET_TEXT3":
          type = "Text";
          break;
        case "FOOTER_WIDGET_TEXT4":
          type = "Text";
          break;
        case "FOOTER_WIDGET_FBLIKEBOX":
          type = "Facebook LikeBox";
          break;
        case "FOOTER_WIDGET_PAYMENT":
          type = "Payment";
          break;
        case "FOOTER_WIDGET_SHIPPING":
          type = "Shipping";
          break;
        case "FOOTER_WIDGET_TAGS":
          type = "Tags";
          break;
        default:
          type = this.widgetType.replace(WIDGET.prefixType, "")
          break;
      }
      type = this.$helper.text.capitalize(type);
      return this.$te(`engine.floatframeTool.floatframeActive.lbl${type}`, this.languageEngine) ? this.$t(`engine.floatframeTool.floatframeActive.lbl${type}`, this.languageEngine) : type;
    },
    checkShowReHeight() {
      switch (this.widgetType) {
        case "SECTION_WIDGET_IMAGE_GALLERY":
          return this.component.style.layout == 3 && this.component.style.crop != 'original' && this.detectDevice != 'mobile' ? true : false;
        default:
          return false;
      }
    },

    // Elements
    elemWidgetActive() {
      if (this.widgetActive.id == 'HEADER_WIDGET_MENU' && this.siteComponents.HEADER.style.layout == '05') {  
        // Header widget menu ใน Header layout 05 จะแบ่งออกเป็น 3 ก้อนอยู่แยกกัน เลยต้องคำนวน position floatframe ใหม่
        let menuRow1 = document.getElementsByClassName('hmenu-row-1')[0]
        let menuRow2 = document.getElementsByClassName('hmenu-row-2')[0]
        let compHeaderMenu = document.getElementById('comp-HEADER_WIDGET_MENU')
        let menuRow2PosBottom = menuRow2 ? menuRow2.getBoundingClientRect().bottom : 0
        let menuRow1PosLeft = menuRow1 ? menuRow1.getBoundingClientRect().left : 0
        let menuRow1Width = menuRow1 ? menuRow1.offsetWidth : 0
        let menuRow2Width = menuRow2 ? menuRow2.offsetWidth : 0
        let headerMenuPosTop = compHeaderMenu ? compHeaderMenu.getBoundingClientRect().top : 0
        return {
          params: {
            position: {
              width: Math.max(menuRow1Width, menuRow2Width) + 'px',
              height: menuRow2PosBottom > 0 ? (menuRow2PosBottom - headerMenuPosTop) + 'px' : this.widgetActive.position.height,
              top: this.widgetActive.position.top,
              left: menuRow1PosLeft + 'px'
            }
          }
        };
      } else {
        return {
          params: {
            position: {
              width: this.widgetActive.position.width,
              height: this.widgetActive.position.height,
              top: this.widgetActive.position.top,
              left: this.widgetActive.position.left,
            }
          }
        };
      }
    },

    compMargin() {
        return this.component && this.component.style && this.component.style.marginTop <= 88 ?  this.component.style.marginTop : 30  || 30;
    },
    isOverScroll() {
        const diff = this.scrollPosition - (this.topElementPosition - this.compMargin ) ;
        if (diff >= -10 || this.isHeaderWidgetOnTopBar) {
          return true;
        } else {
          return false;
        }
    },
    HEADER() {
      return this.siteComponents.HEADER;
    },
    getMainPage() {
      const mainPageID =
        this.siteComponents &&
        this.siteComponents.MAIN_PAGE &&
        this.siteComponents.MAIN_PAGE.properties &&
        this.siteComponents.MAIN_PAGE.properties.pageID;
      return mainPageID;
    },
    oversection() {
      return (
        this.sitePageID == this.getMainPage && this.HEADER.style.isEnableOverSection
      );
    },
    indexSection() {
      return this.section_id && this.CONTENT_CONTAINER.componentsID.indexOf(this.section_id);
    },
    isFirstSection() {
      return this.section_id && this.indexSection == 0;
    },
    attr() {
      if(this.isOverScroll) {
        return "marginBottom"
      } else {
        return "marginTop"
      }
    },
    cellComponent() {
      return this.parent_id && this.components[this.parent_id]
    },
    cellWidth() {
      if (!this.parent_id) return 0;
      let id = "comp-" + this.parent_id;
      const target = document.getElementById(id);

      let rect = target ? target.getBoundingClientRect() : {};
      let width = rect.width;
      let cellPaddingLeft =
        this.components[this.parent_id].style.paddingLeft;
      let cellPaddingRight =
        this.components[this.parent_id].style.paddingRight;

      width = Math.floor(width - (cellPaddingLeft + cellPaddingRight));

      return {width,cellPaddingLeft,cellPaddingRight}
    },
    indexCell() {
      if (this.components[this.grid_id]) {
        if (this.detectDevice == 'mobile') {
          return this.components[this.grid_id].componentsIDMobile.indexOf(this.parent_id);
        } else {
          return this.components[this.grid_id].componentsID.indexOf(this.parent_id);
        }
      } else {
        return 0;
      }
    },
    indexWidget() {
      return this.cellComponent && this.cellComponent.componentsID.indexOf(this.widgetActive.id);
    },
    isFirstIndex() {
      return this.indexWidget == 0;
    },
    widgetWidth() {
      if (!this.component) return 0;
      let id = "comp-" + this.component.id;
      const target = document.getElementById(id);

      let rect = target ? target.getBoundingClientRect() : {};
      let width = rect.width;

      return Math.floor(width)
    },
    isHaveTopGap() {
      if (!this.component) return 0
      let id = `resize-margin-top-${this.component.id}`;
      const target = document.getElementById(id);

      let rect = target ? target.getBoundingClientRect() : {};
      let height = rect.height;

      return height
    },
    isWidgetOverlap() {
      return  this.component && !this.isHeaderWidget && !this.isFooterWidget && this.widgetWidth >= this.cellWidth.width && this.cellComponent.style.paddingTop == 0 && this.cellComponent.style.paddingLeft == 0 && this.isFirstIndex && this.isHaveTopGap <= 1
    },
    framePosition() {
      return this.widgetActive.position
    },
    hideTool() {
      return this.detectDevice !== "desktop" && ((this.isHeaderWidget && this.widgetType != 'HEADER_WIDGET_TEXT') || (this.widgetTypeShow ==  'Image Gallery' || this.widgetTypeShow == 'Album' || this.widgetTypeShow == 'Blog' || this.widgetTypeShow == 'Product' || this.widgetTypeShow == 'Faq' || this.widgetTypeShow == 'Product Brand' || this.widgetTypeShow == 'Coupon' || this.widgetType == 'SECTION_WIDGET_PRODUCT_CATEGORY' || this.widgetType == 'SECTION_WIDGET_TABLE'))
    }
  },
  methods: {
    translatePixelToPct({ translate, scale = 0, frame }) {
      return (translate / (scale - frame)) * 100;
    },
    translatePctToPixel({ pct, scale = 0, frame }) {
      return (pct / 100) * (scale - frame);
    },
    callbackResize() {
      this.resetWidgetToolPosition();
    },
    removeWidget() {
      // let isExecuted = confirm("Are you sure to delete this widget?");
      // if (isExecuted) {

      this.$store.dispatch("designIframe/component/removeComponent", {
        id: this.widgetActive.id,
      });

      this.$store.dispatch("designIframe/frame/setSlideWidgetActive", {})
      this.$store.dispatch("designIframe/frame/setWidgetActive", {})

      if (this.parent_id && this.parent_id.includes("slc")) {
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
          component_id: this.slideSectionActive.id,
          index: this.slideSectionActive.index
        });

        this.$store.dispatch("designIframe/component/elActive", {
              elementID: ["component", this.parent_id],
            });
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {
          component_id: this.parent_id,
        });
        this.$store.dispatch("designIframe/frame/setSlideWidgetActive", {})
      }
      // }
    },
    resetWidgetToolPosition() {
      this.$nextTick(function () {
        this.$store.dispatch("designIframe/component/setComponentAction", {
          component_id: this.widgetActive.id,
          type: "WIDGET",
          action: "ACTIVE",
        });
      });
    },
    calPositionTool() {
      let activeFrame = document.getElementById('widget-active-frame')
      let toolEl = document.getElementById('widget-tool-badge')

      if (activeFrame && toolEl) {
        let activeFrameWidth = activeFrame.getBoundingClientRect().width
        let toolPosRight= toolEl.getBoundingClientRect().right
        if (toolPosRight > this.screenWidth) {
            this.positionTool = {
              right: 0 - activeFrameWidth / 4 + 'px'
            }
        } else {
            this.positionTool = {}
        }
      }        
    },
    goTo(type) {
      if (!this.preview) {
        switch (type) {
          case "section": {
            var compID = this.section_id;

            this.$store.dispatch("designIframe/frame/setSectionActive", {
              component_id: compID,
              name: compID,
            });
            this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
            this.$store.dispatch("designIframe/frame/setCellActive", {});
            this.$store.dispatch("designIframe/frame/setCellHover", {});
            this.$store.dispatch("designIframe/frame/setWidgetActive", {});
            this.$store.dispatch("designIframe/frame/setWidgetHover", {});
            this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
            this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});

            let noneSetting = false;
            SECTION_TYPE_NONE_SETTING.find((type) => {
              Object.entries(this.components).forEach((item) => {
                if (type === item[1].type && item[1].id === this.section_id) {
                  noneSetting = true;
                }
              })
            });
            if (noneSetting) {
              this.$store.dispatch("design/component/elActive", {});
            } else {
              this.$store.dispatch("design/component/elActive", {
                elementID: ["component", compID],
              });
            }
            break;
          }
          case "cell": {
            
            if (this.parent_id && this.grid_id) {
              this.$store.dispatch("designIframe/frame/setSectionActive", {
                component_id: this.section_id,
                name: this.section_id,
              });
              this.$store.dispatch("designIframe/component/elActive", {
                elementID: ["component", this.parent_id],
              });
              this.$store.dispatch("designIframe/frame/setCellActive", {
                component_id: this.parent_id,
                parent_id: this.grid_id,
              });
            }
            this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
            this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
            this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
            this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
            this.$store.dispatch("designIframe/frame/setWidgetHover", {})
            this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
            this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
            this.$store.dispatch("designIframe/frame/setSectionHover", {});
            break;
          }
          case "grid": {
            
            if (this.parent_id && this.grid_id) {
              this.$store.dispatch("designIframe/frame/setSectionActive", {
                component_id: this.section_id,
                name: this.section_id,
              });
              this.$store.dispatch("designIframe/component/elActive", {
                elementID: ["component", this.parent_id],
              });
              this.$store.dispatch("designIframe/frame/setCellActive", {
                component_id: this.parent_id,
                parent_id: this.grid_id,
              });
            }
            this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
            this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
            this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
            this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
            this.$store.dispatch("designIframe/frame/setWidgetHover", {})
            this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
            this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
            this.$store.dispatch("designIframe/frame/setSectionHover", {});
            break;
          }
          default:
            break;
        }
      }
    },
    duplicateWidget() {
      this.$store.commit("designIframe/setStatePath", {
        value: {
          widgetID: this.widgetActive.id,
        },
        path: "/component/addComponent/widget",
      });

      this.$store.dispatch("designIframe/component/duplicateComponent", {
        parent_id: this.parent_id,
        component_id: this.widgetActive.id,
      });

      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
  },
  mounted() {
    this.refs.widgetTool = this.$refs.widgetTool;
  },
};
</script>

<style scoped>
.badge {
  background: #ffffff !important;
  border: 1px solid #dee3e6 !important;
  font-weight: normal;
}
/* #widget-active-tool { 
  left : calc(100% - var(--tool-width));
} */
</style>